<template>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <job-list-component />
      </v-flex>
    </v-layout>
</template>
<script>
import JobListComponent from '@/components/JobList';
export default {
  name: 'JobIndex',
  components: {
    JobListComponent
  },
  data () {
      return {
      }
    },
}
</script>
